import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getServicePaymentAndSteps = (serviceId) => {
  return http.get(
    `${getBaseUrl()}/service_payment_and_step/${serviceId}`
  );
};
export const getServicedSteps = (serviceId) => {
  return http.get(
    `${getBaseUrl()}/service_step/${serviceId}`
  );
};

export const updateServiceStep = data => {
  return http.put(
    `${getBaseUrl()}/service_step/${data.id}`,
    data
  );
};

export const updateServiceStepDone = data => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/service_step_done/${data.id}`,
    data
  );
};